import { getNationIconByCode2 } from "@/utils/utils";
import { useSelector } from "react-redux";

const NationAvatar = (props) => {
  const { code, code3, size } = props;
  const { countries } = useSelector(state => state.app);

  if (!code && !code3) return null;

  let code2 = code;
  if (!code2) {
    if (!countries?.length) return null;
    code2 = countries.find(country => country.code3 === code3)?.code;
  }
  if (!code2) return null;

  const imgSrc = getNationIconByCode2(code2);
  let imgSize = size ?? '32px'
  return (<>
    <img style={{display: 'inline-block', width: imgSize, height: imgSize}} src={imgSrc} />
  </>)
}

export default NationAvatar